import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';

import { slugify } from '../../../helpers';

const AdminPaymentPlanFeatures = ({ plan }) => {
  const intl = useIntl();

  const getFeatures = () => {
    if (plan === 'free') {
      return [
        intl.formatMessage({ defaultMessage: 'No upload or download limits' }),
        intl.formatMessage({ defaultMessage: 'Any file type' }),
        intl.formatMessage({ defaultMessage: 'AI tagging' }),
        intl.formatMessage({ defaultMessage: 'Dropbox, Box, and Google Drive integration' }),
        intl.formatMessage({ defaultMessage: 'Custom download sizes' }),
        intl.formatMessage({ defaultMessage: 'Custom tag categories' }),
        intl.formatMessage({ defaultMessage: 'Two-Factor Authentication (2FA)' }),
        intl.formatMessage({ defaultMessage: 'Link to cloud projects' }),
      ];
    }

    if (plan === 'essential') {
      return [
        intl.formatMessage({ defaultMessage: 'Facial recognition' }),
        intl.formatMessage({ defaultMessage: 'Custom branding' }),
        intl.formatMessage({ defaultMessage: 'File annotations' }),
        intl.formatMessage({ defaultMessage: 'File statuses' }),
        intl.formatMessage({ defaultMessage: 'File versioning' }),
        intl.formatMessage({ defaultMessage: 'Custom download sizes' }),
        intl.formatMessage({ defaultMessage: 'Custom Tag Categories' }),
      ];
    }

    if (plan === 'pro') {
      return [
        intl.formatMessage({ defaultMessage: 'Duplicate file detection' }),
        intl.formatMessage({ defaultMessage: 'Image cropping and resizing' }),
        intl.formatMessage({ defaultMessage: 'Expiration dates on files' }),
        intl.formatMessage({ defaultMessage: 'File watermarking' }),
        intl.formatMessage({ defaultMessage: 'Guest Upload pages' }),
        intl.formatMessage({ defaultMessage: 'Adobe integrations' }),
      ];
    }

    if (plan === 'premium') {
      return [
        intl.formatMessage({ defaultMessage: 'Reports' }),
        intl.formatMessage({ defaultMessage: 'File FTP' }),
        intl.formatMessage({ defaultMessage: 'Content Portals' }),
        intl.formatMessage({ defaultMessage: 'IPTC and EXIF metadata mapping' }),
        intl.formatMessage({ defaultMessage: 'Single Sign-On Integration' }),
        intl.formatMessage({ defaultMessage: 'Onboarding support' }),
        intl.formatMessage({ defaultMessage: 'Dedicated account support' }),
        intl.formatMessage({ defaultMessage: 'Unlimited training' }),
      ];
    }

    return [];
  };

  const features = getFeatures();

  if (features.length === 0) return null;

  return (
    <ul className="fa-ul">
      {features.map(feature => (
        <li key={slugify(feature)}>
          <span className="fa-li">
            <i className="fa-regular fa-arrow-right" />
          </span>
          {feature}
        </li>
      ))}
      <li>
        <span className="fa-li">
          <i className="fa-regular fa-arrow-right" />
        </span>
        <a href="https://stockpress.co/pricing/#features" target="_blank" rel="noreferrer">
          {intl.formatMessage({ defaultMessage: 'See all features' })}
        </a>
      </li>
    </ul>
  );
};

AdminPaymentPlanFeatures.propTypes = {
  plan: PropTypes.string.isRequired,
};

export default AdminPaymentPlanFeatures;
